import * as firebase from "firebase"
require("firebase/firestore")

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getVideosByCategory = category => {
  return (
    firebase.firestore().collection('videos')
    .where('component', '==', category.component)
    .where('category', '==', getDocById('categories', category.id))
    .get()
    .then(querySnapshot => {
      let results = []
      querySnapshot.forEach(async doc => {
        results.push({
          id: doc.id,
          ...doc.data()
        })
      })
      return results
    })
  )
}

export const getCategoriesByCategory = category_parent => {
  return (
    firebase.firestore().collection('categories')
    .where('component', '==', category_parent.component)
    .where('parent', '==', getDocById('categories', category_parent.id))
    .get()
    .then(querySnapshot => {
      let results = []
      querySnapshot.forEach(async doc => {
        results.push({
          id: doc.id,
          ...doc.data()
        })
      })
      return results
    })
  )
}

export const getCategoriesByComponent = component => {
  return (
    firebase.firestore().collection('categories')
    .where('component', '==', getDocById('components', component.id))
    .where('parent', '==', null)
    .get()
    .then(querySnapshot => {
      let results = []
      querySnapshot.forEach(async doc => {
        results.push({
          id: doc.id,
          ...doc.data()
        })
      })
      return results
    })
  )
}

export const getDocumentsFromParent = (collection, conditional, parent_collection, id) => {
  return (
    firebase.firestore().collection(collection)
    .where(conditional, '==', getDocById(parent_collection, id))
    .get()
    .then(querySnapshot => {
      let results = []
      querySnapshot.forEach(async doc => {
        results.push({
          id: doc.id,
          ...doc.data()
        })
      })
      return results
    })
  )
}

export const getDocumentsFromCollection = (collection) => {
  let collectionRef = firebase.firestore().collection(collection)
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(async doc => {
          results.push({
            id: doc.id,
            ...doc.data()
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}
